import React, { useState } from "react";
import styled from "styled-components";
import { color } from "../Utils/Constant";
import emailjs from "@emailjs/browser";
import { ContactData } from "../Data/ContactData";

// styles
const FormContainer = styled.div`
  padding: 10px;
  padding-bottom: 20px;
`;
const FormTitle = styled.p`
  text-align: center;
  margin-bottom: 20px;
  font-size: 18px;
  color: ${color.primary};
`;
const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
const Input = styled.input`
  width: 100%;
  padding: 12px;
  border-radius: 5px;
  border: solid 1px ${color.light_gray};
  &:focus {
    border-color: ${color.gray};
    outline: none;
  }
`;
const TextArea = styled.textarea`
  width: 100%;
  padding: 12px;
  border-radius: 5px;
  border: solid 1px ${color.light_gray};
  min-height: 50px;
  resize: none;
  &:focus {
    border-color: ${color.gray};
    outline: none;
  }
`;
// const EmailPhoneContainer = styled.div`
//   display: flex;
//   gap: 10px;
//   @media (max-width: 768px) {
//     flex-direction: column;
//   }
// `;
const SubmitButton = styled.button`
  background-color: ${color.primary};
  border: none;
  padding: 12px;
  font-weight: 500;
  border-radius: 5px;
  width: 50%;
  align-self: center;
  color: ${color.white};
  font-size: 15px;
  cursor: pointer;
  transition: background 0.3s ease;
  &:hover {
    background-color: ${color.dark_primary};
  }
`;

const EnquiryForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("form submitted :", formData);

    const emailObject = ContactData.find((item) => item.name === "Email");
    const recipientEmail = emailObject ? emailObject.details : null;
    console.log(recipientEmail);
    

    if (!recipientEmail) {
      alert("Email id not found");
      return;
    }

    const emailParams = {
      to_email: recipientEmail,
      from_name: formData.name,
      from_email: formData.email,
      phone: formData.phone,
      message: formData.message,
    };

    emailjs
      .send(
        "service_k8ssuhy",
        "template_ch9qgkx",
        emailParams,
        "fUBILNndk2igTumXd"
      )
      .then(
        (res) => {
          console.log("Email sent successfully", res);
          alert("Form Submitted successfully");
          setFormData({
            name: "",
            email: "",
            phone: "",
            message: "",
          });
        },
        (err) => {
          console.log("Failed to sent email", err);
          alert("Failed to sent email");
          // alert("Form Submitted successfully");
        }
      );
  };
  return (
    <FormContainer>
      <FormTitle>ENQUIRY FORM</FormTitle>
      <Form onSubmit={handleSubmit}>
        <Input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        {/* <EmailPhoneContainer> */}
          <Input
            type="email"
            name="email"
            value={formData.email}
            placeholder="Email"
            onChange={handleChange}
            required
          />
          <Input
            type="tel"
            name="phone"
            value={formData.phone}
            placeholder="Mobile"
            onChange={handleChange}
            required
          />
        {/* </EmailPhoneContainer> */}
        <TextArea
          value={formData.message}
          name="message"
          placeholder="Your Message"
          onChange={handleChange}
        />
        <SubmitButton type="submit">Send</SubmitButton>
      </Form>
    </FormContainer>
  );
};

export default EnquiryForm;
